<template>
  <div id="glossary">
    <InnerContent>
      <ContentHeader title="Glossary of terms" />
    </InnerContent>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader";

export default {
  name: "Glossary",
  components: {
    ContentHeader,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/scss/styles.scss";

#glossary {
  width: 100%;
  position: relative;
  background: $blue-dark;

  .inner-content {
    padding-bottom: 20px;
  }
}

ol {
  margin-left: -20px;
  column-count: 2;
  column-gap: 80px;

  @include breakpoint(sm) {
    column-count: 1;
  }

  li {
    margin-top: 10px;
    padding-left: 10px;
    font-size: rem(16px);
    color: $white;
    break-inside: avoid-column;
  }
}
</style>
